/**
 * ブラウザ環境で使用される、グローバルなwindowオブジェクトを提供します。
 *
 * @return ブラウザのグローバルWindowオブジェクト。
 */
const win = window

export default win
